import { Spin, SpinProps } from 'antd';
import clsx from 'clsx';

import './Loader.styles.scss';

interface ILoaderProps extends SpinProps {
  isLoading: boolean;
  isFullHeight?: boolean;
}

export const Loader = ({ size, children, isLoading, isFullHeight }: ILoaderProps) => (
  <Spin
    size={size}
    spinning={isLoading}
    wrapperClassName={clsx(isFullHeight && 'loader-full-height')}
  >
    {children}
  </Spin>
);
